<template>
    <div>
        <div v-if="allAutomations.length" >
            <div v-for="automation in allAutomations" :key="automation.id" class="flex flex-column border-1 p-3 pl-5 pr-1 br-10 mt-2">
                <div class="flex justify-content-between mb-2">
                    <div class="flex w-75 align-items-baseline">
                        <label class="text-capitalize mx-2">Automation name:</label>
                        <input class="form-control w-75" v-model="automation.name" :key="automation.id" @focusout="saveAutomationName(automation)" style="border-radius: 5px;">
                    </div>
                    <div>
<!--                        <i class="mr-1 fa fa-share-alt" role="button" v-if="canShare" @click="shareAutomation(automation.id)"></i>-->
                        <i class="mr-1 fa fa-pencil" role="button" @click="editAutomation(automation.id)"></i>
                        <i class="mr-1 fa fa-copy" role="button" @click="copyAutomation(automation.id)"></i>
                        <i class="fa fa-trash" role="button" @click="deleteAutomation(automation.id)"></i>
                        <b-form-checkbox name="check-button" :checked="automation.user_enabled === 1 ? true : false" switch @change="enableAutomation(automation.id)"
                                         :id="'automationButtonSwitch-'+automation.id" class="inline-block ml-2" size="lg">
                        </b-form-checkbox>
                    </div>
                </div>
                <div class="br-10 trigger flex align-items-center">
                    <div class="flex align-items-center">
                        When a
                        <button class="btn btn-primary mx-2 text-capitalize">{{ automation.trigger_object }}</button>
                        <button v-if="['activity_added', 'activity_completed', 'activity_due'].includes(automation.trigger_type)" class="btn btn-light-green mr-1 text-capitalize">{{ automation.trigger_field.replace('_', ' ') }} Activity</button>
                        is
                        <button class="btn btn-light-green mx-2 text-capitalize">{{ automation.trigger_type.replace('activity', '').replace('_', ' ') }}</button>
                        then...
                    </div>
                    <automation-action-list
                        :automation="automation"
                        :masks="masks"
                    ></automation-action-list>
                </div>
            </div>

            <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-content-center mt-5">
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                >
                </b-pagination>
            </div>

        </div>
        <div v-else class="text-center">No automation found</div>
    </div>
</template>

<script>

    import AutomationActionList from "./utils/automation-action-list.vue";

    export default {
        name:'my-automations',
        components: {AutomationActionList},
        props: ['userId', 'canShare', 'masks'],
        data() {
            return {
                allAutomations: [],
                selected: [],
                pagination: {
                    data: [],
                    meta: {},
                    links: {},
                },
            }
        },
        mounted() {
            this.fetchAutomations();
        },
        methods: {
            goToPage(page) {
                this.fetchAutomations(page);
            },
            fetchAutomations(page = 1) {
                const self = this;
                axios.get(route('automation.get-automations', {page: page, userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone})).then(({data}) => {
                    self.allAutomations = data.data;
                    self.pagination = data;
                });
            },
            editAutomation(id) {
                window.location = route('automation.edit', {automation: id})
            },
            copyAutomation(id) {
                window.location = route('automation.copy-automation', {automation: id})
            },
            deleteAutomation(id) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        axios.post(route('automation.delete-automation', {automationId: id })).then((response) => {
                            if (response.status) {
                                this.getToast().fire({
                                    type: 'success',
                                    title: response.data.message
                                });
                                this.fetchAutomations();
                            } else {
                                this.getToast().fire({
                                    type: 'error',
                                    title: response.data.message
                                });
                            }
                        });
                    }
                });

            },
            shareAutomation(id) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to share this automation!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Yes!'
                }).then((result) => {
                    if (result.value) {
                        axios.post(route('automation.share-automation', {automationId: id })).then((response) => {
                            if (response.status) {
                                this.getToast().fire({
                                    type: 'success',
                                    title: response.data.message
                                });
                                this.fetchAutomations();
                            } else {
                                this.getToast().fire({
                                    type: 'error',
                                    title: response.data.message
                                });
                            }
                        });
                    }
                });
            },
            enableAutomation(id){
                let payload = {
                    automationId: id,
                    enable:'user-enable'
                }
                axios.post(route('automation.enable-automation', payload)).then((response) => {
                    if (response.status) {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.fetchAutomations();
                    } else {
                        this.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
            },
            saveAutomationName(automation) {
                if(automation.name.trim() === "") {
                    automation.name = automation.previous_name;
                    this.getToast().fire({
                        type: 'error',
                        title: 'Automation name is required'
                    });
                    return false;
                }
                if(automation.name !== automation.previous_name){
                    axios.post(route('automation.update-name', {automation_id: automation.id, name: automation.name})).then((response) => {
                        if(response.data.status) {
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            this.fetchAutomations();
                        }
                        else {
                            this.getToast().fire({
                                type: 'error',
                                title: response.data.message
                            });
                            automation.name = automation.previous_name;
                        }
                    });
                }
            }
        }
    }
</script>
<style scoped>
.br-10{
    border-radius: 10px;
}
.trigger{
    padding: 8px 20px;
    background: #ebebeb;
}
.btn-purple{
    background: #6e7ff2;
}
.btn-yellow{
    background: #f8f582;
}
.btn-light-green{
    background: #9af6c0;
}
.btn-light-red{
    background: #f87676;
}
</style>
